import { render, staticRenderFns } from "./icon-select.vue?vue&type=template&id=39659606&scoped=true&"
import script from "./icon-select.ts?vue&type=script&lang=ts&"
export * from "./icon-select.ts?vue&type=script&lang=ts&"
import style0 from "./icon-select.scss?vue&type=style&index=0&id=39659606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39659606",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
